import React, {
  useEffect,
  useRef,
  useState,
} from "react";

export default function Reveal({ children }) {
  const ref = useRef(null);

  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);

          observer.disconnect();
        }
      },
      {
        threshold: 0.12,
      }
    );

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <div
      ref={ref}
      className={`gf-reveal ${
        visible ? "active" : ""
      }`}
    >
      {children}
    </div>
  );
}
